import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { fetchBlogs } from '../../store/slices/blogSlice';
import BlogCard from '../components/BlogCard';

const BlogListPage = () => {
    const dispatch = useAppDispatch();
    
    const { blogs, loading } = useAppSelector((state) => state.blog);

    useEffect(() => {
        dispatch(fetchBlogs({ page: 1, limit: 50 }));
    }, [dispatch]);

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Header */}
            <div className="bg-white border-b border-gray-200">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                    <h1 className="text-3xl font-bold text-gray-900">Travel Insights & News</h1>
                    <p className="mt-2 text-gray-600">Discover the latest in private aviation and luxury travel</p>
                </div>
            </div>

            {/* Blog Grid */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                {loading && blogs.length === 0 ? (
                    <div className="flex justify-center items-center py-20">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#ffd200]"></div>
                    </div>
                ) : blogs.length === 0 ? (
                    <div className="bg-white rounded-lg shadow-sm p-8 text-center text-gray-500">
                        No blogs available at the moment.
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {blogs.map((blog) => (
                            <BlogCard key={blog.id} blog={blog} />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default BlogListPage;
